const defaultState = {
    jwtToken: '',
}

export default (state = defaultState, action: any) => {
    if (action.type === 'setToken') {
        let initState = JSON.parse(JSON.stringify(state))
        initState.jwtToken = action.value
        return initState
    }
    return state
}